const parseSuperAdminIds = (rawValue) => {
  return String(rawValue || '')
    .split(',')
    .map((value) => parseInt(value.trim(), 10))
    .filter((value) => Number.isInteger(value) && value > 0);
};

export const SUPER_ADMIN_IDS = parseSuperAdminIds(process.env.REACT_APP_SUPER_ADMIN_IDS);

export const isSuperAdmin = (e_id) => SUPER_ADMIN_IDS.includes(parseInt(e_id, 10));
